/*global translate*/

import React, { Component } from 'react'
import { connect } from 'react-redux'

global.isclient && require('./rxGroupList.css')
const { rxaget, rxChangeSlug, stringToColour } = global.rootRequire('classes/ulti')
const { chooseGroupAction } = global.rootRequire('redux')
const { checkNameGroup, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { rxgetLocal } = global.rootRequire('classes/request')

const chatDB = global.rootRequire('classes/indexedDB').default

class RxGroupList extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      groups: [],
      groups_origin: [],      
    }
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.users = rxaget(this.props, 'user.users', {})
    
    try {
      this.loadGroups()
    } catch (e) { console.log(e) }
    this.checkImage = {}
    const timenow = Math.floor(Date.now() / 1000)
    let checkImageObj = rxaget(this.props, 'netaBlobs.data', {}) || {}
    if (checkImageObj && typeof(checkImageObj) === "object" && Object.keys(checkImageObj).length > 0) {
      for (let keyImg of Object.keys(checkImageObj)) {
        let created_at = rxaget(checkImageObj[keyImg], 'created_at', 0)
        if ((timenow - created_at) < 43200) {
          this.checkImage[keyImg] = checkImageObj[keyImg]
        }
      }
    }
  }

  loadGroups() {
    chatDB.groups.orderBy('last_sort').toArray().then(groups => {
      this.setState({
        groups: groups,
        groups_origin: groups
      })
    }).catch(e => {console.log(e)})
  }

  checkAvatarGroup (group) {
    const users = this.users
    let result = false
    if (group.avatar_url) {
      result = true
    } else if (group.type === 3 && !group.avatar_url) {
      if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length === 2 && group.occupants_uins.indexOf(this.userid.toString()) !== -1) {
        const arruserid = group.occupants_uins.filter(o => o !== this.userid.toString())
        if (arruserid && arruserid.constructor === Array && arruserid[0] && users[arruserid[0]] && users[arruserid[0]].profile_url) {
          result = true
        }
      }
    }
    return result
  }

  loadImgStatic (obj, name) {
    if (obj.sender_avatar) {
      return global.rxu.config.get_static + obj.sender_avatar
    } else if (obj.avatar_url) {
      return global.rxu.config.get_static + obj.avatar_url
    } else if (obj.type === 3 && !obj.avatar_url) {
      const users = this.users
      if (obj && obj.occupants_uins && obj.occupants_uins.constructor === Array && obj.occupants_uins.length === 2 && obj.occupants_uins.indexOf(this.userid.toString()) !== -1) {
        const arruserid = obj.occupants_uins.filter(o => o !== this.userid.toString())
        if (arruserid && arruserid.constructor === Array && arruserid[0] && users[arruserid[0]] && users[arruserid[0]].profile_url) {
          return global.rxu.config.cdn_endpoint + users[arruserid[0]].profile_url
        }
      } else {
        return './images/default/static/avadefault.svg'
      }
    } else {
      return './images/default/static/avadefault.svg'
    }
  }

  checkNameGroup (group) {
    const users = this.users
    let result = ''
    if (group.type === 3) {
      if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length === 2 && group.occupants_uins.indexOf(this.userid.toString()) !== -1) {
        const arruserid = group.occupants_uins.filter(o => o !== this.userid.toString())
        if (arruserid && arruserid.constructor === Array) {
          const user = users[arruserid[0]]
          result = (user && user.full_name) ? user.full_name : ''
        }
      } else if (group && group.owner_uin) {
        const user = users[group.owner_uin.toString()]
        result = (user && user.full_name) ? user.full_name : ''
      } else {
        result = users[group.owner_uin.toString()] || group.name
      }
    } else {
      if (!group.name) {
        const occupants_uins = group.occupants_uins || []
        if (occupants_uins && occupants_uins.length > 0) {
          const groupname = []
          occupants_uins.forEach(uin => {
            const fullname = (users[uin.toString()] && users[uin.toString()].full_name) ? users[uin.toString()].full_name : ''
            if (fullname) {
              groupname.push(fullname)
            }
          })
          result = groupname.join(', ')
        }
      } else {
        result = group.name || ''
      }
    }
    return result || translate('Stranger')
  }

  async onChangeSearch (e) {
    const _usersinfo = rxaget(global.rxu.json(rxgetLocal('rxusers'), {}), 'users')
    let value = e.target.value
    let arrGroups = []
    try {
      let arrUsers = await chatDB.users.filter((user) => { if (user && user.phone && user.full_name) { return (rxChangeSlug(user?.phone).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(user?.full_name).indexOf(rxChangeSlug(value)) !== -1) } }).toArray()
      let arrUids = (arrUsers.length > 0) ? arrUsers.map(user => user.id) : []
      
      arrGroups = this.state.groups_origin.filter(o => {
        let uname_info = false
        if (o.type === 3) {
          const userId = rxaget(o.occupants_uins.filter((id) => (id !== String(rxaget(this.props, 'netaauth.user.id')))), [0])        
          if (arrUids.indexOf(Number(userId)) !== -1) {
            uname_info = true
          }
        }
        
        try {
          if (o.group_fullname && rxChangeSlug(o.group_fullname) && (rxChangeSlug(o.group_fullname).indexOf(rxChangeSlug(value)) !== -1 || (uname_info && (o.type === 3)))) {
            return true
          } else {
            return false
          }
        } catch (e) {
          console.log(e)
          return false
        }
      })
    } catch(e) {}
    
    this.setState({ groups: arrGroups })
  }

  chooseGroupForward (group) {
    this.props.chooseGroupAction(group)
    this.props.chooseGroupForward(group)
  }

  render () {
    const linkava = global.rxu.config.get_avatar  
    return (
      <div className='groups-container'>
        <div className='groups-opacity' onClick={e => { this.props.closePopupGroup() }} />

        <div className='groups-box'>
          <div className='groups-search'>
            <input placeholder='Search' className='place-holder-center' onChange={e => { this.onChangeSearch(e) }} />
          </div>
          <div className='groups-box-main'>
            {this.state.groups.length > 0 ? (
              this.state.groups.map((ele, index) =>
                <div className='zgroupitem clearfix' key={index} onClick={e => { this.chooseGroupForward(ele) }}>
                  <div className='zgroup_avatar'>
                    {ele.avatar_url 
                      ? 
                      <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-group images-static'
                      onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                      :
                      (this.users[ele.partner_id] && this.users[ele.partner_id]['profile_url'] 
                        ? <img src={`${global.rxu.config.cdn_endpoint}` + this.users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-usergroup images-static' 
                        onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                         : this.checkImage[linkava + ele.partner_id] && <img src={this.checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                      )
                    }
                    {
                      !(ele.avatar_url || (this.users[ele.partner_id] && this.users[ele.partner_id]['profile_url']) )
                      &&<span className='ava-span' style={{ background:  `${changeColorAva(rxaget(ele, 'group_id', ''))}`  }}>
                        {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
                      </span>  
                    }
                  </div>
                  <div className='zgroup_maininfo'>
                    <div className='zgroup_name zgroup_name_margin '>{rxaget(ele, 'group_fullname', '')} </div>
                  </div>
                </div>
              )
            ) : (<div className='zgroup-emty'> </div> )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  langValue: state.langValue,
  user: state.user,
  auth: state.auth,
  netaauth: state.netaauth,
  netaBlobs: state.netaBlobs,
  netaGroups: state.netaGroups
})

const mapDispatchToProps = {
  chooseGroupAction
}

const ComponentGroupListW = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxGroupList)

export default ComponentGroupListW
